<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>学员跟踪记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" lable-position="right">
        <Row :gutter="32">
          <Col :span="8">
          <Form-item label="下次联系日期">
            <Row>
              <Col span="11">
              <Date-picker type="date" placeholder="请选择日期" format="yyyy-MM-dd"
                           @on-change="startTimeDateChange"
                           v-model="queryParam.startTimeDate" style="width: 100%;"></Date-picker>
              </Col>
              <Col span="2" style="text-align: center">
              -</Col>
              <Col span="11">
              <Date-picker type="date" placeholder="请选择日期" format="yyyy-MM-dd"
                           @on-change="endTimeDateChange"
                           v-model="queryParam.endTimeDate" style="width: 100%;"></Date-picker>
              </Col>
            </Row>
          </Form-item>
          </Col>
          <Col :span="8">
          <Form-item label="下次联系人">
            <Select filterable placeholder="全部" @on-change="search" clearable
                    v-model.number="queryParam.nextHandlerId">
              <Option v-for="item in nextHandler"
                      :value="item.id" :key="item.id">{{ item.nickname }}
              </Option>
            </Select>
          </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="操作人">
              <Input placeholder="模糊" name="mobile" v-model="queryParam.createName"/>
            </Form-item>
          </Col>
          <Col :span="8">
          <Form-item label="学生ID" prop="id">
            <Input name="id" v-model="queryParam.uid"/>
          </Form-item>
          </Col>
          <Col :span="8">
          <Form-item label="学生姓名">
            <Input placeholder="模糊" name="nickname" v-model="queryParam.nickname"/>
          </Form-item>
          </Col>
          <Col :span="8">
          <Form-item label="学生手机号">
            <Input placeholder="模糊" name="mobile" v-model="queryParam.mobile"/>
          </Form-item>
          </Col>
          <Col :span="8">
          <Form-item label="记录属性">
            <Select v-model="queryParam.traceType" transfer>
              <Option value="1">新注册学生</Option>
              <Option value="11">分配记录</Option>
              <Option value="21">试听课记录</Option>
              <Option value="31">成交记录</Option>
              <Option value="41">交接记录</Option>
              <Option value="51">绑定记录</Option>
              <Option value="61">上课跟进记录</Option>
              <Option value="71">转介绍跟进记录</Option>
              <Option value="99">其他</Option>
              <Option value="100">注册备注</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :span="8">
          <Form-item label="添加时间">
            <Row>
              <Col span="11">
              <Date-picker type="date" placeholder="请选择日期" format="yyyy-MM-dd"
                           @on-change="addStartTimeDateChange"
                           v-model="addsTimeDate" style="width: 100%;"></Date-picker>
              </Col>
              <Col span="2" style="text-align: center">
              -</Col>
              <Col span="11">
              <Date-picker type="date" placeholder="请选择日期" format="yyyy-MM-dd"
                           @on-change="addEndTimeDateChange"
                           v-model="addeTimeDate" style="width: 100%;"></Date-picker>
              </Col>
            </Row>
          </Form-item>
          </Col>
          <Col>
          <Col span='2'>
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search">搜索
          </Button>
          </Col>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" icon="plus-round"
        @click="$router.push('/user/userTrackEdit')">添加记录
      </Button>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/userTrack/list"
          :params="queryParam" :onLoading="onLoading" :onSelection="onSelection" operator=""></List>
    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>
    <AiDrawer
      :visible.sync="aiVisible"
      :uid="aiUid"
      page-route="/user/userTrackList"
      default-task-type="ADVISOR_AFTER_CLASS"
      @on-executed="onAiExecuted"
      @on-close="onAiClose"
    />
    <Modal v-model="contentVisible" title="跟踪记录内容" width="720" :mask-closable="false">
      <div style="margin-bottom: 12px;">
        <Radio-group v-model="contentViewMode" type="button" size="small" @on-change="switchContentView">
          <Radio label="markdown">Markdown</Radio>
          <Radio label="raw" :disabled="!contentRawText">原文</Radio>
        </Radio-group>
        <span v-if="!contentRawText" style="margin-left:8px;color:#999;font-size:12px;">无原始内容</span>
      </div>
      <div v-if="contentViewMode === 'markdown'" ref="contentExportArea" class="track-md track-md-dialog" v-html="contentHtml"></div>
      <pre v-else ref="contentExportArea" class="track-raw-dialog">{{ contentRawText }}</pre>
      <div slot="footer">
        <Button :loading="exportImageLoading" :disabled="exportImageLoading || (contentViewMode==='markdown' ? !contentHtml : !contentRawText)" @click="exportContentPng">导出 PNG</Button>
        <Button type="primary" @click="contentVisible = false">关闭</Button>
      </div>
    </Modal>
  </div>

</template>
<script>
    import { renderSimpleMarkdown } from '@/utils/simpleMarkdown'
  import TrackContentPreview from './TrackContentPreview.vue'
  import html2canvas from 'html2canvas'
import commonUtils from '@/tools/commonUtils.js'
  import UserInfoModal from '../crm/UserInfoModal.vue'
  import AiDrawer from '@/components/ai/AiDrawer'
  import { bindAiAllowed } from '@/tools/aiAccess'
  export default {
    components: {
      TrackContentPreview,
      UserInfoModal,
      AiDrawer
    },
    data () {
      let $constant = this.$constant
      // let $moment = this.$moment
      return {
        searchLoading: false,
        reload: 0,
        aiVisible: false,
        aiUid: null,
        aiAllowed: false,
        contentVisible: false,
        contentHtml: '',
        contentRawText: '',
        contentViewMode: 'markdown',
        contentMeta: {},
        exportImageLoading: false,
        editUser: false,
        uid: null,
        addsTimeDate: '',
        addeTimeDate: '',
        queryParam: {
          uid: '',
          mobile: '',
          nickname: '',
          startTimeDate: '',
          endTimeDate: '',
          addStartTimeDate: '',
          addEndTimeDate: '',
          traceType: '',
          trackType: '',
          createName: '',
          startTime: '',
          endTime: '',
          addStartTime: '',
          addEndTime: '',
        },
        nextHandler: [],
        title: [
          {
            title: '学生ID/姓名',
            width: 180,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.openInfoModal(row.uid)}}, row.uid + '-' + row.nickname)
            }
          },
          {
            title: '添加时间',
            width: 170,
            align: 'center',
            key: 'createTime'
          },
          {
            title: '记录属性',
            align: 'center',
            width: 170,
            render: (h, params) => {
              let trackType = params.row.trackType
              let traceTypeEnum = $constant.getEnum($constant.userTraceType, trackType)
              return h('span', traceTypeEnum && traceTypeEnum.text)
            }
          },
          {
            title: '课程顾问',
            width: 110,
            align: 'center',
            key: 'adviserName',
            render: (h, params) => {
              let row = params.row
              return h('span', row.adviserName)
            }
          },
          {
            title: '学导',
            width: 110,
            align: 'center',
            key: 'studyAdviserName',
            render: (h, params) => {
              let row = params.row
              return h('span', row.studyAdviserName)
            }
          },
          {
            title: '内容',
            // width: 700,
            align: 'left',
            minWidth: 220,
            key: 'content',
            render: (h, params) => {
              let row = params.row
              return h('TrackContentPreview', {
                props: { content: row.content },
                on: { view: () => this.openContentView(row) }
              })
            }
          },
          {
            title: '下次联系日期',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let content = params.row.nextHandlerTime
              if (!content || content === '0000-00-00 00:00:00') {
                return h('span', '0')
              }
              return h('Poptip', {
                props: {
                  trigger: 'hover',
                  placement: 'top',
                  transfer: true
                }
              }, [
                h('span', {
                  style: {
                    display: 'inline-block',
                    width: '100px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    verticalAlign: 'middle'
                  }
                }, content),
                h('div', {
                  slot: 'content',
                  style: {
                    maxWidth: '360px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    textAlign: 'left'
                  }
                }, content)
              ])
            }
          },
          {
            title: '下次联系人',
            width: 110,
            align: 'center',
            key: 'nextHandlerName',
            render: (h, params) => {
              let row = params.row
              return h('span', row.nextHandlerName)
            }
          },
          {
            title: '操作人',
            width: 110,
            align: 'center',
            key: 'createName',
          },
          {
            title: '操作',
            width: 140,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return ('span', [
                h('a', {on: {click: () => this.showMore(row.uid)}}, '更多'),
                this.aiAllowed ? h('br') : null,
                this.aiAllowed ? h('a', {on: {click: () => this.openAiDrawer(row.uid)}}, 'AI') : null,
              ])
            }
          },
        ]
      }
    },
    mounted: function () {
      let self = this
      let query = self.$route.query
      if (query.addStartTime) {
        this.addsTimeDate = parseInt(query.addStartTime) * 1000
      }
      if (query.addEndTime) {
        this.addeTimeDate = parseInt(query.addEndTime) * 1000
      }
      this.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
        self.nextHandler = res.data
      })
    },
    created: function () {
      bindAiAllowed(this)
      let row = this.$route.query.row
      if (row) {
        this.queryParam.uid = row.uid
      }
    },
    methods: {
      closeModal (val) {
        this.uid = null
        this.editUser = val
      },
      openInfoModal (val) {
        this.uid = val
        let {href} = this.$router.resolve({
          name: 'userPayDetail',
          query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserTrackList'}})
        window.open(href, '_blank')
      },
      showMore (uid) {
        localStorage.setItem('userTraceUid', uid)
        this.$router.push({path: '/user/personUserTrackList'})
      },
      getTrackType (type) {
        let typeNum = commonUtils.getShortNumByTraceType(type)
        let typeName = this.$constant.getEnum(this.$constant.userTraceType, typeNum)
        return typeName && typeName.text
      },
      openContentView (row) {
        if (!row || !row.content) {
          this.$Message.warning('暂无内容')
          return
        }
        this.contentMeta = {
          uid: row.uid || '',
          id: row.id || '',
          createTime: row.createTime || ''
        }
        this.contentHtml = renderSimpleMarkdown(row.content)
        this.contentRawText = row.contentRaw || ''
        this.contentViewMode = 'markdown'
        this.contentVisible = true
      },
      switchContentView () {
      },
      exportContentPng () {
        let el = this.$refs.contentExportArea
        if (!el || (this.contentViewMode === 'markdown' ? !this.contentHtml : !this.contentRawText)) {
          this.$Message.warning('暂无内容可导出')
          return
        }
        this.exportImageLoading = true
        let self = this
        // Modal body / .track-md-dialog 有 max-height+overflow，html2canvas 只会截可见区。
        // 离屏克隆整页高度再截（参考 LevelRecordList 的 scrollWidth/Height），弹窗内仍可滚动查看。
        let width = Math.max(el.clientWidth || 0, 680)
        let holder = document.createElement('div')
        holder.setAttribute('data-track-png-export', '1')
        holder.style.cssText = 'position:absolute;left:-10000px;top:0;width:' + width + 'px;background:#fff;'
        let clone = el.cloneNode(true)
        clone.className = (el.className || '').replace(/\btrack-md-dialog\b/g, ' ').replace(/\s+/g, ' ').trim()
        if ((' ' + clone.className + ' ').indexOf(' track-md ') < 0) {
          clone.className = (clone.className + ' track-md').trim()
        }
        clone.style.cssText = 'max-height:none!important;overflow:visible!important;height:auto!important;width:' + width + 'px;background:#fff;padding:8px;box-sizing:border-box;'
        holder.appendChild(clone)
        document.body.appendChild(holder)
        let cleanup = function () {
          if (holder && holder.parentNode) {
            holder.parentNode.removeChild(holder)
          }
        }
        void clone.offsetHeight
        let w = Math.max(clone.scrollWidth, width)
        let h = Math.max(clone.scrollHeight, clone.offsetHeight, 1)
        html2canvas(clone, {
          scale: 2,
          backgroundColor: '#ffffff',
          useCORS: true,
          logging: false,
          width: w,
          height: h,
          windowWidth: w,
          windowHeight: h
        }).then(canvas => {
          cleanup()
          let meta = self.contentMeta || {}
          let stamp = String(meta.createTime || '').replace(/[^\d]/g, '')
          let link = document.createElement('a')
          link.download = '跟踪记录_' + (meta.uid || '') + (meta.id ? '_' + meta.id : '') + (stamp ? '_' + stamp : '') + '.png'
          link.href = canvas.toDataURL('image/png')
          link.click()
          self.exportImageLoading = false
          self.$Message.success('导出成功')
        }).catch(() => {
          cleanup()
          self.exportImageLoading = false
          self.$Message.error('导出失败')
        })
      },
      openAiDrawer (uid) {
        this.aiUid = uid
        this.aiVisible = true
      },
      onAiClose () {
        this.aiVisible = false
        this.aiUid = null
      },
      onAiExecuted () {
        this.reload = new Date().getTime()
      },
      search () {
        if (this.queryParam.uid) {
          this.showMore(this.queryParam.uid)
          return
        }
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      onSelection (selection) {
        this.selection = selection
      },
      delAll () {
        this.$refs.dataList.delAll()
      },
      startTimeDateChange (value) {
        if (value) {
          this.queryParam.startTime = (Date.parse(new Date(value)) / 1000) - 28800
        } else {
          this.queryParam.startTime = ''
        }
      },
      endTimeDateChange (value) {
        if (value) {
          this.queryParam.endTime = (Date.parse(new Date(value)) / 1000) + 57599
        } else {
          this.queryParam.endTime = ''
        }
      },
      addStartTimeDateChange (value) {
        if (value) {
          this.queryParam.addStartTime = (Date.parse(new Date(value)) / 1000) - 28800
        } else {
          this.queryParam.addStartTime = ''
        }
      },
      addEndTimeDateChange (value) {
        if (value) {
          this.queryParam.addEndTime = (Date.parse(new Date(value)) / 1000) + 57599
        } else {
          this.queryParam.addEndTime = ''
        }
      }
    }
  }
</script>


<style lang="less" scoped>
  .btn-wrap {
    display: flex;
    justify-content: end;
    margin-top: 24px;
    margin-bottom: 12px;
  }

.track-md { text-align: left; line-height: 1.5; font-size: 14px; }
.track-raw-dialog {
  max-height: 60vh;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  padding: 8px;
  background: #fafafa;
  border: 1px solid #eee;
  font-size: 13px;
  line-height: 1.6;
}
.track-md-dialog {
  max-height: 60vh;
  overflow: auto;
  background: #fff;
  padding: 8px 4px;
}
.track-md /deep/ .md-table { border-collapse: collapse; width: 100%; margin: 4px 0; }
.track-md /deep/ .md-table th, .track-md /deep/ .md-table td { border: 1px solid #e8e8e8; padding: 2px 6px; }
.track-md /deep/ h2, .track-md /deep/ h3, .track-md /deep/ h4 { margin: 6px 0 4px; font-size: 14px; }
.track-md /deep/ ul, .track-md /deep/ ol { padding-left: 18px; margin: 4px 0; }
.track-md /deep/ blockquote { margin: 4px 0; padding-left: 8px; border-left: 3px solid #ddd; color: #666; }
.track-md /deep/ p { margin: 2px 0; }
</style>



// WEBPACK FOOTER //
// UserTrackList.vue?98693956